import {
  HISTORICAL_TRANSFER_QUANTITIES_MODULE,
  INCOMPLETE_TRANSFER_MODULE,
  INVENTORY_COUNT_GROUP_MODULE,
  INVENTORY_COUNT_MODULE,
  ORDER_MODULE,
  STAND_WORKSHEET_MODULE,
  TRANSFER_GROUP_TEMPLATE_MODULE,
  TRANSFER_MODULE,
} from '@app/routes';
import { ENTITY_TYPES } from '../types/enums';

/**
 * document path constants
 */
const DOCUMENT_PATH = {
  CREATE_BY: 'created_by',
  CREATE_AT: 'created_at',
  STATUS_HISTORY: 'status_history',
  UPDATE_BY: 'updated_by',
  UPDATE_AT: 'updated_at',
};

const ENTITY_MODULE = {
  [ENTITY_TYPES.ORDER]: ORDER_MODULE,
  [ENTITY_TYPES.TRANSFER]: TRANSFER_MODULE,
  [ENTITY_TYPES.STAND_WORKSHEET]: STAND_WORKSHEET_MODULE,
  [ENTITY_TYPES.INVENTORY_COUNT]: INVENTORY_COUNT_MODULE,
  [ENTITY_TYPES.INVENTORY_COUNT_GROUP]: INVENTORY_COUNT_GROUP_MODULE,
  [ENTITY_TYPES.HISTORICAL_QUANTITIES]: HISTORICAL_TRANSFER_QUANTITIES_MODULE,
  [ENTITY_TYPES.INCOMPLETE_TRANSFER]: INCOMPLETE_TRANSFER_MODULE,
  [ENTITY_TYPES.TRANSFER_GROUP_TEMPLATE]: TRANSFER_GROUP_TEMPLATE_MODULE,
};

export { DOCUMENT_PATH, ENTITY_MODULE };
